module.exports = __webpack_public_path__ + "img/logo.4356582d.png";